import { render, staticRenderFns } from "./HeroComponent.vue?vue&type=template&id=55505185&scoped=true&"
import script from "./HeroComponent.vue?vue&type=script&lang=js&"
export * from "./HeroComponent.vue?vue&type=script&lang=js&"
import style0 from "./HeroComponent.vue?vue&type=style&index=0&id=55505185&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55505185",
  null
  
)

export default component.exports